import {contactSchema} from '../common/schema'
import {z} from 'zod'
export const siteContactSchema = z.object({
  siteContact: contactSchema
})
